import React from 'react'

export default props => (
    <div className='box-header'>
        <h3 className='box-title'>{props.title} <small>{props.small}</small></h3>
    </div>
)
